import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddressSearch from 'components/AddressSearch';
import PickupList from 'components/PickupList';
import MapView from 'components/MapView';
import {
  getGarbageDays,
  getYardDays,
  getRecyclingDays,
  getBrushDays,
  getCouncilDistrict,
  getSuperDistrict,
  getFireDistrict,
} from 'services/GISService';

function App() {
  const [fetchingData, setFetchingData] = useState(false);
  const [data, setData] = useState(null);
  const [graphics, setGraphics] = useState([]);
  const [garbageDay, setGarbageDay] = useState('');
  const [yardDay, setYardDay] = useState('');
  const [recyclingDay, setRecyclingDay] = useState('');
  const [brushDay, setBrushDay] = useState('');
  const [councilDistrict, setCouncilDistrict] = useState('');
  const [superDistrict, setSuperDistrict] = useState('');
  const [fireDistrict, setFireDistrict] = useState('');
  const [mapExpanded, setMapExpanded] = useState(false);

  const handleAddressFound = async (addressData) => {
    console.log('addressData:', addressData);
    setData(addressData);
    setFetchingData(true);
    if (addressData) {
      let graphicsData = [];
      const x = addressData.location.x;
      const y = addressData.location.y;

      const garbageData = await getGarbageDays(x, y);
      console.log('garbageData:');
      console.log(garbageData);
      console.log(`garbage day: ${garbageData.attributes.PickUpDay}`);
      setGarbageDay(garbageData);
      // graphicsData.push(garbageData);

      const yardData = await getYardDays(x, y);
      console.log(`yard day: ${yardData.attributes.PickUpDay}`);
      setYardDay(yardData);
      // graphicsData.push(yardData);

      const recyclingData = await getRecyclingDays(x, y);
      console.log(`recycling day: ${recyclingData.attributes.PickUpDay}`);
      setRecyclingDay(recyclingData);
      // graphicsData.push(recyclingData);

      const brushData = await getBrushDays(x, y);
      console.log(`brush day: ${brushData.attributes.ROUTE}`);
      setBrushDay(brushData);
      // graphicsData.push(brushData);

      const councilDistrictData = await getCouncilDistrict(x, y);
      console.log(
        `council district: ${councilDistrictData.attributes.District}`
      );
      setCouncilDistrict(councilDistrictData);
      graphicsData.push(councilDistrictData);

      const superDistrictData = await getSuperDistrict(x, y);
      console.log(`super district: ${superDistrictData.attributes.District}`);
      setSuperDistrict(superDistrictData);
      // graphicsData.push(superDistrictData);

      const fireDistrictData = await getFireDistrict(x, y);
      console.log(`fire district: ${fireDistrictData.attributes.DIST_ID}`);
      setFireDistrict(fireDistrictData);
      // graphicsData.push(fireDistrictData);

      setGraphics(graphicsData);
    }
    setFetchingData(false);
  };

  const handleSearchTextCleared = () => {};

  return (
    // <Container component='main' /*maxWidth='xs'*/>
    <Box
      sx={{
        margin: 2,
      }}
    >
      <Box
        sx={{
          margin: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <AddressSearch
          onAddressFound={handleAddressFound}
          fetchingData={fetchingData}
          onSearchTextCleared={handleSearchTextCleared}
        />
        <div>
          <Typography>Please enter an address above</Typography>
        </div>
      </Box>
      {data && (
        <Box
          sx={{
            margin: 1,
          }}
        >
          <PickupList
            addressData={data}
            garbageDay={garbageDay}
            yardDay={yardDay}
            recyclingDay={recyclingDay}
            brushDay={brushDay}
            councilDistrict={councilDistrict}
            superDistrict={superDistrict}
            fireDistrict={fireDistrict}
          />
        </Box>
      )}

      <Accordion
        square
        expanded={mapExpanded}
        onChange={() => setMapExpanded(!mapExpanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#FFFFFF' }} />}
          sx={{ backgroundColor: '#00529b', color: '#FFFFFF' }}
        >
          <Typography>Map</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <MapView location={data} graphics={graphics} />
        </AccordionDetails>
      </Accordion>
      {/* </Container> */}
    </Box>
  );
}

export default App;
